import ExternalMenu from './ExternalMenu';

export default ExternalMenu;
